import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var _dec, _class;

import { injectable } from 'inversify';
import 'reflect-metadata';
var LayerModelPlugin = (_dec = injectable(), _dec(_class = function () {
  function LayerModelPlugin() {
    _classCallCheck(this, LayerModelPlugin);
  }

  _createClass(LayerModelPlugin, [{
    key: "apply",
    value: function apply(layer) {
      layer.hooks.init.tap('LayerModelPlugin', function () {
        layer.prepareBuildModel();
        layer.buildModels();
        layer.styleNeedUpdate = false;
      });
      layer.hooks.beforeRenderData.tap('DataSourcePlugin', function () {
        layer.prepareBuildModel();
        layer.clearModels();
        layer.buildModels();
        layer.layerModelNeedUpdate = false;
        return false;
      });
    }
  }]);

  return LayerModelPlugin;
}()) || _class);
export { LayerModelPlugin as default };
//# sourceMappingURL=LayerModelPlugin.js.map